import image0 from './WhatsApp Image 2026-06-10 at 11.49.16 AM (1).jpeg';
import image1 from './WhatsApp Image 2026-06-10 at 11.49.16 AM (2).jpeg';
import image2 from './WhatsApp Image 2026-06-10 at 11.49.16 AM.jpeg';
import image3 from './WhatsApp Image 2026-06-10 at 11.49.17 AM (1).jpeg';
import image4 from './WhatsApp Image 2026-06-10 at 11.49.17 AM (2).jpeg';
import image5 from './WhatsApp Image 2026-06-10 at 11.49.17 AM (3).jpeg';
import image6 from './WhatsApp Image 2026-06-10 at 11.49.17 AM.jpeg';
import image7 from './WhatsApp Image 2026-06-10 at 11.49.18 AM (1).jpeg';
import image8 from './WhatsApp Image 2026-06-10 at 11.49.18 AM (2).jpeg';
import image9 from './WhatsApp Image 2026-06-10 at 11.49.18 AM (3).jpeg';
import image10 from './WhatsApp Image 2026-06-10 at 11.49.18 AM.jpeg';
import image11 from './WhatsApp Image 2026-06-10 at 11.49.19 AM (1).jpeg';
import image12 from './WhatsApp Image 2026-06-10 at 11.49.19 AM (2).jpeg';
import image13 from './WhatsApp Image 2026-06-10 at 11.49.19 AM (3).jpeg';
import image14 from './WhatsApp Image 2026-06-10 at 11.49.19 AM.jpeg';
import image15 from './WhatsApp Image 2026-06-10 at 11.49.20 AM (1).jpeg';
import image16 from './WhatsApp Image 2026-06-10 at 11.49.20 AM (2).jpeg';
import image17 from './WhatsApp Image 2026-06-10 at 11.49.20 AM (3).jpeg';
import image18 from './WhatsApp Image 2026-06-10 at 11.49.20 AM.jpeg';
import image19 from './WhatsApp Image 2026-06-10 at 11.49.21 AM (1).jpeg';
import image20 from './WhatsApp Image 2026-06-10 at 11.49.21 AM (2).jpeg';
import image21 from './WhatsApp Image 2026-06-10 at 11.49.21 AM (3).jpeg';
import image22 from './WhatsApp Image 2026-06-10 at 11.49.21 AM.jpeg';
import image23 from './WhatsApp Image 2026-06-10 at 11.49.22 AM (1).jpeg';
import image24 from './WhatsApp Image 2026-06-10 at 11.49.22 AM (2).jpeg';
import image25 from './WhatsApp Image 2026-06-10 at 11.49.22 AM (3).jpeg';
import image26 from './WhatsApp Image 2026-06-10 at 11.49.22 AM (4).jpeg';
import image27 from './WhatsApp Image 2026-06-10 at 11.49.22 AM.jpeg';
import image28 from './WhatsApp Image 2026-06-10 at 11.49.23 AM (1).jpeg';
import image29 from './WhatsApp Image 2026-06-10 at 11.49.23 AM (2).jpeg';
import image30 from './WhatsApp Image 2026-06-10 at 11.49.23 AM.jpeg';
import image31 from './WhatsApp Image 2026-06-10 at 11.49.24 AM (1).jpeg';
import image32 from './WhatsApp Image 2026-06-10 at 11.49.24 AM (2).jpeg';
import image33 from './WhatsApp Image 2026-06-10 at 11.49.24 AM (3).jpeg';
import image34 from './WhatsApp Image 2026-06-10 at 11.49.24 AM (4).jpeg';
import image35 from './WhatsApp Image 2026-06-10 at 11.49.24 AM.jpeg';
import image36 from './WhatsApp Image 2026-06-10 at 11.49.25 AM (1).jpeg';
import image37 from './WhatsApp Image 2026-06-10 at 11.49.25 AM (2).jpeg';
import image38 from './WhatsApp Image 2026-06-10 at 11.49.25 AM (3).jpeg';
import image39 from './WhatsApp Image 2026-06-10 at 11.49.25 AM.jpeg';
import image40 from './WhatsApp Image 2026-06-10 at 11.49.26 AM (1).jpeg';
import image41 from './WhatsApp Image 2026-06-10 at 11.49.26 AM (2).jpeg';
import image42 from './WhatsApp Image 2026-06-10 at 11.49.26 AM (3).jpeg';
import image43 from './WhatsApp Image 2026-06-10 at 11.49.26 AM.jpeg';
import image44 from './WhatsApp Image 2026-06-10 at 11.49.27 AM (1).jpeg';
import image45 from './WhatsApp Image 2026-06-10 at 11.49.27 AM (2).jpeg';
import image46 from './WhatsApp Image 2026-06-10 at 11.49.27 AM (3).jpeg';
import image47 from './WhatsApp Image 2026-06-10 at 11.49.27 AM (4).jpeg';
import image48 from './WhatsApp Image 2026-06-10 at 11.49.27 AM.jpeg';
import image49 from './WhatsApp Image 2026-06-10 at 11.49.28 AM (1).jpeg';
import image50 from './WhatsApp Image 2026-06-10 at 11.49.28 AM (2).jpeg';
import image51 from './WhatsApp Image 2026-06-10 at 11.49.28 AM (3).jpeg';
import image52 from './WhatsApp Image 2026-06-10 at 11.49.28 AM.jpeg';
import image53 from './WhatsApp Image 2026-06-10 at 11.49.29 AM (1).jpeg';
import image54 from './WhatsApp Image 2026-06-10 at 11.49.29 AM (2).jpeg';
import image55 from './WhatsApp Image 2026-06-10 at 11.49.29 AM (3).jpeg';
import image56 from './WhatsApp Image 2026-06-10 at 11.49.29 AM.jpeg';
import image57 from './WhatsApp Image 2026-06-10 at 11.49.30 AM (1).jpeg';
import image58 from './WhatsApp Image 2026-06-10 at 11.49.30 AM (2).jpeg';
import image59 from './WhatsApp Image 2026-06-10 at 11.49.30 AM (3).jpeg';
import image60 from './WhatsApp Image 2026-06-10 at 11.49.30 AM (4).jpeg';
import image61 from './WhatsApp Image 2026-06-10 at 11.49.30 AM.jpeg';
import image62 from './WhatsApp Image 2026-06-10 at 11.49.31 AM (1).jpeg';
import image63 from './WhatsApp Image 2026-06-10 at 11.49.31 AM (2).jpeg';
import image64 from './WhatsApp Image 2026-06-10 at 11.49.31 AM.jpeg';

const galleryImages = [
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-16-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.16 AM (1).jpeg",
    src: image0
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-16-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.16 AM (2).jpeg",
    src: image1
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-16-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.16 AM.jpeg",
    src: image2
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-17-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.17 AM (1).jpeg",
    src: image3
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-17-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.17 AM (2).jpeg",
    src: image4
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-17-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.17 AM (3).jpeg",
    src: image5
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-17-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.17 AM.jpeg",
    src: image6
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-18-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.18 AM (1).jpeg",
    src: image7
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-18-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.18 AM (2).jpeg",
    src: image8
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-18-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.18 AM (3).jpeg",
    src: image9
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-18-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.18 AM.jpeg",
    src: image10
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-19-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.19 AM (1).jpeg",
    src: image11
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-19-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.19 AM (2).jpeg",
    src: image12
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-19-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.19 AM (3).jpeg",
    src: image13
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-19-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.19 AM.jpeg",
    src: image14
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-20-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.20 AM (1).jpeg",
    src: image15
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-20-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.20 AM (2).jpeg",
    src: image16
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-20-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.20 AM (3).jpeg",
    src: image17
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-20-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.20 AM.jpeg",
    src: image18
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-21-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.21 AM (1).jpeg",
    src: image19
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-21-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.21 AM (2).jpeg",
    src: image20
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-21-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.21 AM (3).jpeg",
    src: image21
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-21-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.21 AM.jpeg",
    src: image22
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-22-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.22 AM (1).jpeg",
    src: image23
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-22-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.22 AM (2).jpeg",
    src: image24
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-22-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.22 AM (3).jpeg",
    src: image25
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-22-am-4',
    name: "WhatsApp Image 2026-06-10 at 11.49.22 AM (4).jpeg",
    src: image26
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-22-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.22 AM.jpeg",
    src: image27
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-23-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.23 AM (1).jpeg",
    src: image28
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-23-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.23 AM (2).jpeg",
    src: image29
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-23-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.23 AM.jpeg",
    src: image30
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-24-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.24 AM (1).jpeg",
    src: image31
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-24-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.24 AM (2).jpeg",
    src: image32
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-24-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.24 AM (3).jpeg",
    src: image33
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-24-am-4',
    name: "WhatsApp Image 2026-06-10 at 11.49.24 AM (4).jpeg",
    src: image34
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-24-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.24 AM.jpeg",
    src: image35
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-25-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.25 AM (1).jpeg",
    src: image36
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-25-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.25 AM (2).jpeg",
    src: image37
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-25-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.25 AM (3).jpeg",
    src: image38
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-25-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.25 AM.jpeg",
    src: image39
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-26-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.26 AM (1).jpeg",
    src: image40
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-26-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.26 AM (2).jpeg",
    src: image41
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-26-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.26 AM (3).jpeg",
    src: image42
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-26-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.26 AM.jpeg",
    src: image43
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-27-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.27 AM (1).jpeg",
    src: image44
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-27-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.27 AM (2).jpeg",
    src: image45
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-27-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.27 AM (3).jpeg",
    src: image46
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-27-am-4',
    name: "WhatsApp Image 2026-06-10 at 11.49.27 AM (4).jpeg",
    src: image47
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-27-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.27 AM.jpeg",
    src: image48
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-28-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.28 AM (1).jpeg",
    src: image49
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-28-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.28 AM (2).jpeg",
    src: image50
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-28-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.28 AM (3).jpeg",
    src: image51
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-28-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.28 AM.jpeg",
    src: image52
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-29-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.29 AM (1).jpeg",
    src: image53
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-29-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.29 AM (2).jpeg",
    src: image54
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-29-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.29 AM (3).jpeg",
    src: image55
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-29-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.29 AM.jpeg",
    src: image56
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-30-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.30 AM (1).jpeg",
    src: image57
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-30-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.30 AM (2).jpeg",
    src: image58
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-30-am-3',
    name: "WhatsApp Image 2026-06-10 at 11.49.30 AM (3).jpeg",
    src: image59
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-30-am-4',
    name: "WhatsApp Image 2026-06-10 at 11.49.30 AM (4).jpeg",
    src: image60
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-30-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.30 AM.jpeg",
    src: image61
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-31-am-1',
    name: "WhatsApp Image 2026-06-10 at 11.49.31 AM (1).jpeg",
    src: image62
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-31-am-2',
    name: "WhatsApp Image 2026-06-10 at 11.49.31 AM (2).jpeg",
    src: image63
  },
  {
    id: 'whatsapp-image-2026-06-10-at-11-49-31-am',
    name: "WhatsApp Image 2026-06-10 at 11.49.31 AM.jpeg",
    src: image64
  }
];

export default galleryImages;
